import { gql } from "@apollo/client";
import VendorFields from "~/lib/queries/fragments/VendorFields";

export default gql`
  mutation EditVendor($id: ObjectId!, $vendor: VendorInput!) {
    editVendor(id: $id, vendor: $vendor) {
      _id
      ...VendorFields
    }
  }

  ${VendorFields}
`;
